const problemas = [
  {
    icone: 'ri-shield-keyhole-line',
    titulo: 'Síndrome da impostora',
    desc: 'Você entrega resultados incríveis, mas uma voz interna diz que não é suficiente. A qualquer momento vão descobrir que você não merece estar onde está.',
  },
  {
    icone: 'ri-timer-flash-line',
    titulo: 'Procrastinação e sabotagem',
    desc: 'Você sabe exatamente o que fazer, tem as ferramentas, mas na hora H algo te paralisa. Dias viram semanas, semanas viram meses.',
  },
  {
    icone: 'ri-mental-health-line',
    titulo: 'Ansiedade constante',
    desc: 'A mente nunca desliga. Mesmo nos momentos de descanso, uma lista mental interminável te impede de estar presente de verdade.',
  },
  {
    icone: 'ri-money-dollar-circle-line',
    titulo: 'Bloqueio financeiro',
    desc: 'O dinheiro chega, mas também escapa. Ou pior: você sabota as oportunidades de ganhar mais antes mesmo de tentar.',
  },
  {
    icone: 'ri-repeat-line',
    titulo: 'Padrões que se repetem',
    desc: 'Nos relacionamentos, no trabalho, nas escolhas — sempre a mesma história com personagens diferentes. E você não entende por quê.',
  },
  {
    icone: 'ri-emotion-unhappy-line',
    titulo: 'Desconexão com você mesma',
    desc: 'Você cumpre os papéis que o mundo espera, mas em algum momento se perdeu no processo. Quem é você quando ninguém está olhando?',
  },
];

export default function IGProblema() {
  return (
    <section className="py-20 px-5 bg-luxury-black">
      <div className="max-w-lg mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/[0.04] border border-white/10 rounded-full mb-5">
            <i className="ri-search-eye-line text-gold-400 text-sm" />
            <span className="text-[11px] font-bold text-white/50 tracking-[0.18em] uppercase">Você se reconhece?</span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-white leading-tight mb-4">
            Se ao menos <span className="text-gold-400">uma</span> dessas frases soa familiar…
          </h2>
          <p className="text-white/45 text-base leading-relaxed">
            Não é falta de esforço, disciplina ou inteligência. É um padrão mental gravado antes dos 7 anos — que pode ser reprogramado.
          </p>
        </div>

        {/* Cards de problemas */}
        <div className="space-y-3 mb-12">
          {problemas.map((p, i) => (
            <div
              key={i}
              className="flex items-start gap-4 px-5 py-4 rounded-2xl bg-white/[0.03] border border-white/[0.07] hover:border-gold-500/20 hover:bg-white/[0.05] transition-all"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/5 border border-white/10 shrink-0 mt-0.5">
                <i className={`${p.icone} text-lg text-gold-400/70`} />
              </div>
              <div>
                <p className="text-sm font-bold text-white/85 mb-1 leading-tight">{p.titulo}</p>
                <p className="text-xs text-white/40 leading-relaxed">{p.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Divisor com texto */}
        <div className="relative text-center">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gold-500/30 to-transparent" />
          </div>
          <div className="relative inline-block px-5 bg-luxury-black">
            <p className="text-sm text-white/50 font-medium">
              Isso tem nome — e tem solução
            </p>
          </div>
        </div>

        {/* Resposta */}
        <div className="mt-8 bg-gradient-to-br from-gold-500/[0.07] to-transparent border border-gold-500/20 rounded-2xl p-5 text-center">
          <i className="ri-lightbulb-flash-line text-gold-400 text-2xl mb-3 block" />
          <p className="text-sm text-white/65 leading-relaxed">
            Esses são <strong className="text-gold-300 font-semibold">padrões neurológicos</strong> — loops que seu cérebro repete automaticamente. A Programação Neurolinguística (PNL) é a única abordagem que age diretamente nesses loops e os reprograma na raiz.
          </p>
        </div>
      </div>
    </section>
  );
}
